module.exports = __webpack_public_path__ + "static/img/MPR_Icons_minus.7c87ce3a.svg";